import Image from "next/image"

const aiLogos = [
  { src: "/static/images/marketing/logos/ai/claude.png", alt: "Claude" },
  { src: "/static/images/marketing/logos/ai/chatgpt.png", alt: "ChatGPT" },
  {
    src: "/static/images/marketing/logos/ai/perplexity.png",
    alt: "Perplexity",
  },
  { src: "/static/images/marketing/logos/ai/gemini.png", alt: "Gemini" },
  { src: "/static/images/marketing/logos/ai/grok.png", alt: "Grok" },
]

const MCPOutlineIllustration = () => (
  <div style={{ width: 433, height: 245, position: "relative" }}>
    <svg
      width="433"
      height="245"
      viewBox="0 0 433 245"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: "absolute", inset: 0 }}
    >
      {/* Browser window frame */}
      <rect
        x="0.5"
        y="0.5"
        width="432"
        height="244"
        rx="8"
        className="stroke-fg-secondary/30"
      />

      {/* Title bar */}
      <line
        x1="0"
        y1="24"
        x2="433"
        y2="24"
        className="stroke-fg-secondary/20"
      />

      {/* Traffic lights */}
      <circle
        cx="14"
        cy="12"
        r="4"
        className="stroke-fg-secondary/30"
        strokeWidth="1"
      />
      <circle
        cx="28"
        cy="12"
        r="4"
        className="stroke-fg-secondary/30"
        strokeWidth="1"
      />
      <circle
        cx="42"
        cy="12"
        r="4"
        className="stroke-fg-secondary/30"
        strokeWidth="1"
      />

      {/* URL bar */}
      <rect
        x="70"
        y="6"
        width="120"
        height="12"
        rx="4"
        className="stroke-fg-secondary/15"
      />
      <rect
        x="78"
        y="10"
        width="60"
        height="4"
        rx="2"
        className="fill-fg-secondary/15"
      />
    </svg>

    {/* AI logos grid — 2 per row, 3 rows */}
    <div
      style={{
        position: "absolute",
        top: 30,
        left: 0,
        right: 0,
        display: "grid",
        gridTemplateColumns: "36px 36px 36px",
        columnGap: 14,
        rowGap: 8,
        padding: "8px 16px",
      }}
    >
      {aiLogos.map((logo) => (
        <Image
          key={logo.alt}
          src={logo.src}
          alt={logo.alt}
          width={32}
          height={32}
          className="w-9 h-9 rounded-md object-contain opacity-30"
        />
      ))}
    </div>
  </div>
)

export default MCPOutlineIllustration
